import React from 'react';
import classNames from 'classnames';

import cn from 'components/loading/Loading.module.scss';
const { PUBLIC_URL } = process.env;

export const Loading = React.memo((props: { variant: 'dark' | 'light' }) => {
  const { variant } = props;
  return (
    <div className={classNames(cn.loading, { [cn.dark]: variant === 'dark' }, { [cn.light]: variant === 'light' })}>
      <img className={cn.spinner} src={`${PUBLIC_URL}/spinner.gif`} />
    </div>
  );
});
